import { IonCard, IonCardContent, IonLabel } from '@ionic/react';
import { ComponentProps, ReactNode } from 'react';

import Accordion from '@components/accordions/Accordion';
import styles from '@components/accordions/BlockAccordion.module.css';
import BodyCopy from '@components/typography/BodyCopy';
import Heading2 from '@components/typography/Heading2';

type Props = Pick<ComponentProps<typeof Accordion>, 'border' | 'color' | 'content'> & {
  heading: ReactNode;
  subheading?: ReactNode;
};

const BlockAccordion = ({ color, content, heading, subheading, ...accordionProps }: Props) => (
  /* eslint-disable-next-line react/forbid-elements */
  <Accordion
    {...accordionProps}
    color={color}
    content={
      <IonCard className={`ion-no-margin ${styles.accordionContent}`} color={color} slot="content">
        <IonCardContent>{content}</IonCardContent>
      </IonCard>
    }
    header={
      <IonLabel>
        <Heading2>{heading}</Heading2>
        {subheading && <BodyCopy>{subheading}</BodyCopy>}
      </IonLabel>
    }
  />
);

export default BlockAccordion;
